import styled from 'styled-components';

const CustomForm = styled.form`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    width: 100%;
    background: white;
`;

export default CustomForm;



// WEBPACK FOOTER //
// ./src/blocks/Form/CustomForm.jsx